import { Component, OnInit } from '@angular/core';
import { AssessmentService } from 'src/app/core/service/assessment.service';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  selector: 'app-test-dropdowns',
  templateUrl: './test-dropdowns.component.html',
  styleUrls: ['./test-dropdowns.component.scss']
})
export class TestDropdownsComponent implements OnInit
{
  public assessmentTypes = [];
  public languages = [];
  public selectedLanguage = [];
  public selectedPreferred = null;
  public selectedType = null;

  public virtualLanguage: any = {
    itemHeight: 30
  };

  constructor(
    private assessmentService: AssessmentService,
    private dictionaryService: DictionaryService,
    private messageHandlerService: MessageHandlerService)
  {
  }

  public ngOnInit(): void
  {
    this.assessmentService.getCachedAssessmentTypes().subscribe({
      next: (data) =>
      {
        this.assessmentTypes = data;
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
    this.dictionaryService.getCachedLanguages().subscribe({
      next: (data) =>
      {
        this.languages = data;
        this.selectedLanguage.push(data[0]);
      }
    });
  }

  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active || itemArgs.dataItem.name === 'PPH';
  }

}
